import { render, staticRenderFns } from "./WPrecioEntradas.vue?vue&type=template&id=008913de&"
import script from "./WPrecioEntradas.vue?vue&type=script&lang=js&"
export * from "./WPrecioEntradas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports